export default "__VITE_ASSET__Cq3NqiRr__"